<template>
  <div
    class="d-container"
    :class="[{
               'is-paddingless-mobile': paddinglessMobile,
               'is-fluid': fluid,
               'no-padding':noPadding
             }, 
             size 
    ]"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    paddinglessMobile: {
      default: false,
      type: Boolean
    },
    fluid: {
      default: false,
      type: Boolean
    },
    size: {
      default: "",
      type: String
    },
    noPadding: {
      default: false,
      type: Boolean
    }
  }
};
</script>
